export default "__VITE_ASSET__Dd8y5zlx__"